import merge from 'deepmerge';

export const deepmerge = merge;
export const deepcopy = <T>(o: T): T => deepmerge({} as T, o);
export const copy = deepcopy;

/**
 * Custom arrayMerge function that matches all entries from the destinationArray to the entries of the sourceArray by id.
 * If an entry from the destinationArray cannot be found in the sourceArray then it is discarded.
 *
 * This behaviour is derived from the assumption that only the sourceArray entries are relevant to the result
 * (e.g. because the value in the sourceArray was removed and therefore is no longer wanted).
 *
 * Example to illustrate:
 *
 * destinationArray: [{id: 1, ...}, {id: 2, name: x, ...}
 * sourceArray: [{id: 2, name: y, ...}]
 *
 * returnValue: [{id: 2, name: y, ...}]
 */
export function arrayMerge(destinationArray: any[], sourceArray: any[], options) {
  return sourceArray.map((entry) => {
    const index = destinationArray.findIndex((a) => a.id === entry.id);
    let returnValue = entry;

    if (index > -1) {
      returnValue = deepmerge.all([{}, destinationArray[index], entry], {
        arrayMerge,
      });
    }

    return returnValue;
  });
}
